module.exports = __webpack_public_path__ + "img/vip.78302a41.jpg";